import React from "react";
import useObjectInput from "../../../../hooks/useObjectInput";
import "./index.css";

/**
 * Component that renders the last item in a list.
 * item - The item to be rendered.
 */
const LastItem = ({ item }) => {
  
  const { highlightData, setActiveObjectId } = useObjectInput();

  return (
    <React.Fragment key={item?.id}>
      <span
        className="last-item text-underline-hover cp"
        onClick={setActiveObjectId}
        id={item?.id}
        key={item?.id}
        style={
          // Apply yellow background if item's id is in highlightData.dependenciesId
          highlightData.dependenciesId.some((id) => id === item?.id)
            ? { background: "#fac711" }
            // Apply red background if item's id is the same as highlightData.objectId
            : highlightData.objectId === item?.id
            ? { background: "red" }
            // Default to no additional styling
            : {}
        }
      >
        {/* Display the item's name */}
        {item.name}
      </span>
    </React.Fragment>
  );
};

export default LastItem;